import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../stores/Hooks';
import { StatementStatusEnum } from '../models/StatementStatusEnum';
import { dataStore } from '../stores/Context';
import { FileStateEnum } from '../models';
import { ModalTypeEnum } from '../stores/libraries/ModalLibrary';
import { StatementWarningPage } from './StatementWarningPage';
import { StatementPageRightBlock } from './RightBlock/StatementPageRightBlock';
import { StatementStatusComponent } from '../components/StatementStatusComponent';
import { StatementHelpComponent } from '../components/StatementHelpComponent';

export const StatementPage: React.FC<any> = observer(
	() =>
	{
		const { uiState } = useStores();
		const store = uiState.stat;

		let signVisible = uiState.StatementStatus === StatementStatusEnum.Signed
			|| uiState.StatementStatus === StatementStatusEnum.Sent
			|| uiState.StatementStatus === StatementStatusEnum.Received;

		if (uiState.StatementStatus === StatementStatusEnum.NotCreated)
		{
			return (<StatementWarningPage />);
		}


		return (
			<div className="row no-gutters scrolled-container">
				<div className="col-lg">
					<div className="info-on-mobile d-lg-none">
						<button
							className="text-primary text-center link d-flex align-items-center f-14"
							type="button"
							onClick={() => uiState.modal.ShowComponent("Информация по разделу", StatementHelpComponent)}
						>Информация по разделу <img src="./i/icons/question.svg" className="ml-2" alt="Информация по разделу" /></button>
					</div>
					<div className="statement-steps d-lg-none">
						<p className="mb-3">Статусы заявления</p>
						<StatementStatusComponent />
					</div>
					<div className="statements-container">
						<div className="statement-blocks">

							<div className="statement-block">
								<div className="statement-block__link">
									<p className="mb-0"><a className="link" href={dataStore.GetFormLink()} target="_blank" rel="noopener noreferrer nofollow">Заявление_оператора_ЭДО.pdf</a></p>
								</div>
								{(store.FormFileState === FileStateEnum.Succeed && !uiState.IsDisabled) &&
									<button className="btn btn-icon icon-delete" onClick={() => store.DeleteForm()}>
										<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M15.8334 5.34167L14.6584 4.16667L10.0001 8.82501L5.34175 4.16667L4.16675 5.34167L8.82508 10L4.16675 14.6583L5.34175 15.8333L10.0001 11.175L14.6584 15.8333L15.8334 14.6583L11.1751 10L15.8334 5.34167Z" />
										</svg>
									</button>
								}
								{store.FormFileState === FileStateEnum.Waiting &&
									<div className="file-card__action ml-auto d-flex align-items-center">
										<div className="waiting d-flex align-items-center justify-content-center">
											<svg className="loader" width="32" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M74.5059 38.5498C74.5059 58.77 58.1704 75.1055 37.9502 75.1055C17.73 75.1055 1.39453 58.77 1.39453 38.5498C1.39453 18.3297 17.8297 1.99414 38.0498 1.99414C58.1704 1.99414 74.5059 18.3297 74.5059 38.5498ZM6.57408 38.5498C6.57408 55.8814 20.6186 69.926 37.9502 69.926C55.2818 69.926 69.3264 55.8814 69.3264 38.5498C69.3264 21.2183 55.3814 7.07409 38.0498 7.07409C20.7183 7.07409 6.57408 21.2183 6.57408 38.5498Z" fill="#CCDDFF"></path>
												<path d="M72.0157 38.5498C73.4102 38.5498 74.6055 37.3545 74.5059 35.96C74.2071 32.0753 73.3106 28.1907 71.8165 24.5052C70.0236 20.1225 67.3342 16.0387 63.9476 12.652C60.5609 9.26539 56.5767 6.57601 52.0944 4.78309C48.4089 3.28898 44.6239 2.39252 40.6396 2.0937C39.2451 1.99409 38.0498 3.18938 38.0498 4.58387C38.0498 5.97837 39.2451 7.17365 40.6396 7.27326C43.827 7.47247 47.0144 8.26932 50.0026 9.4646C53.7877 11.0583 57.2739 13.3493 60.1625 16.2379C63.0511 19.1265 65.4417 22.6127 66.9358 26.3978C68.2307 29.386 68.9279 32.5734 69.2267 35.8604C69.4259 37.3545 70.5216 38.5498 72.0157 38.5498Z" fill="#0057FF"></path>
											</svg>
										</div>
									</div>
								}
							</div>

							{signVisible &&
								<div className="statement-block">
									<div className="statement-block__link">
										<p className="mb-0">
											<button
												className="btn-as-link break-word-sm"
											onClick={() => uiState.modal.setShowModal(true, ModalTypeEnum.ShowSignature, "Сведения о сертификате электронной подписи")}
										>Заявление_оператора_ЭДО_подпись.sgn</button></p>
									</div>
									{(store.SignFileState === FileStateEnum.Succeed && !uiState.IsDisabled) &&
										<button className="btn btn-icon icon-delete" onClick={() => store.DeleteSign()}>
											<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M15.8334 5.34167L14.6584 4.16667L10.0001 8.82501L5.34175 4.16667L4.16675 5.34167L8.82508 10L4.16675 14.6583L5.34175 15.8333L10.0001 11.175L14.6584 15.8333L15.8334 14.6583L11.1751 10L15.8334 5.34167Z" />
											</svg>
										</button>
									}
									{store.SignFileState === FileStateEnum.Waiting &&
										<div className="file-card__action ml-auto d-flex align-items-center">
											<div className="waiting d-flex align-items-center justify-content-center">
												<svg className="loader" width="32" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path d="M74.5059 38.5498C74.5059 58.77 58.1704 75.1055 37.9502 75.1055C17.73 75.1055 1.39453 58.77 1.39453 38.5498C1.39453 18.3297 17.8297 1.99414 38.0498 1.99414C58.1704 1.99414 74.5059 18.3297 74.5059 38.5498ZM6.57408 38.5498C6.57408 55.8814 20.6186 69.926 37.9502 69.926C55.2818 69.926 69.3264 55.8814 69.3264 38.5498C69.3264 21.2183 55.3814 7.07409 38.0498 7.07409C20.7183 7.07409 6.57408 21.2183 6.57408 38.5498Z" fill="#CCDDFF"></path>
													<path d="M72.0157 38.5498C73.4102 38.5498 74.6055 37.3545 74.5059 35.96C74.2071 32.0753 73.3106 28.1907 71.8165 24.5052C70.0236 20.1225 67.3342 16.0387 63.9476 12.652C60.5609 9.26539 56.5767 6.57601 52.0944 4.78309C48.4089 3.28898 44.6239 2.39252 40.6396 2.0937C39.2451 1.99409 38.0498 3.18938 38.0498 4.58387C38.0498 5.97837 39.2451 7.17365 40.6396 7.27326C43.827 7.47247 47.0144 8.26932 50.0026 9.4646C53.7877 11.0583 57.2739 13.3493 60.1625 16.2379C63.0511 19.1265 65.4417 22.6127 66.9358 26.3978C68.2307 29.386 68.9279 32.5734 69.2267 35.8604C69.4259 37.3545 70.5216 38.5498 72.0157 38.5498Z" fill="#0057FF"></path>
												</svg>
											</div>
										</div>
									}
								</div>
							}
						</div>
					</div>

				</div>
				<div className="col-lg-auto sidebar d-none d-lg-block">
					<StatementPageRightBlock />
				</div>
			</div>
		);
	}
)
